export const adminPrefix = '/admin'
export const sellerPrefix = '/seller'
export const userPrefix = '/buyer'
export const providerPrefix = '/sales-rep'
export const salesDeveloperPrefix = '/sales-developer'
